import { render, staticRenderFns } from "./FileSidebar.vue?vue&type=template&id=4e0d7642&"
import script from "./FileSidebar.vue?vue&type=script&lang=js&"
export * from "./FileSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports